import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import Button from "../Button";

import settings from "../../config";
import Header from "../Header";
import Input from "../Input/Input";
import Select from "../Select/Select";

const FabricVariantTransactionForm = () => {
  const navigate = useNavigate();
  const { productionAssetId = "", productionAssetVariantTransactionId = null } =
    useParams();
  const [variants, setVariants] = useState([]);

  const [formData, setFormData] = useState({
    productionAssetId,
    fabricTransactionVariantId: "",
    productionAssetVariantTransactionId,
    price: 0,
    processingDate: "",
    seasonId: "",
  });

  const [seasons, setSeasons] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await axios.post(`${settings.api}seasons/`);

      if (response.data.statusCode === 200) {
        setSeasons(response.data.data);
      }
    })();
  }, []);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    (async () => {
      const response = await axios.post(
        `${settings.api}fabric/variants-transactions`,
      );

      setVariants(response.data.data);
    })();
  }, []);

  useEffect(() => {
    if (productionAssetVariantTransactionId) {
      (async () => {
        const response = await axios.post(
          `${settings.api}production-assets/variant-view-transaction`,
          {
            productionAssetVariantTransactionId,
          },
        );

        setFormData(response.data.data[0]);
      })();
    }
  }, [productionAssetVariantTransactionId]);

  useEffect(() => {
    if (productionAssetVariantTransactionId) {
      (async () => {
        const response = await axios.post(
          `${settings.api}production-assets/variant-view-transaction`,
          {
            productionAssetVariantTransactionId,
          },
        );

        setFormData(response.data.data[0]);
      })();
    }
  }, [productionAssetVariantTransactionId]);

  return (
    <form
      dir="rtl"
      onSubmit={async (e) => {
        e.preventDefault();

        const response =
          (productionAssetVariantTransactionId &&
            (await axios.post(
              `${settings.api}production-assets/update-variant-transaction`,
              formData,
            ))) ||
          (await axios.post(
            `${settings.api}production-assets/create-variant-transaction`,
            formData,
          ));

        if (response.data.statusCode === 200) {
          navigate(`/production-asset/variants/${productionAssetId}`);
        }
      }}
    >
      <div className="w-full">
        <Header title="استماره دفعات متطلبات الانتاج" />

        <div className="flex flex-col w-full lg:w-1/2 m-auto gap-4">
          <Select
            label="الاصناف"
            value={formData.fabricTransactionVariantId}
            onChange={onChange}
            name="fabricTransactionVariantId"
          >
            <option value="">اختر</option>
            {variants.map((variant) => (
              <option
                key={variant.fabricTransactionVariantId}
                value={variant.fabricTransactionVariantId}
              >
                {`${variant.variantCode} - ${variant.variantName}`}
              </option>
            ))}
          </Select>

          <Input
            label="التكلفه"
            value={formData.price}
            onChange={onChange}
            name="price"
            required
          />

          <Input
            label="تاريخ الدفعه"
            placeholder="yyyy-mm-dd"
            value={formData.processingDate}
            name="processingDate"
            onChange={onChange}
            required
            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
            type="date"
          />

          <Select
            label="اسم الموسم"
            value={formData.seasonId}
            onChange={onChange}
            name="seasonId"
          >
            <option value="">اختر</option>
            {seasons.map((season) => (
              <option key={season.seasonId} value={season.seasonId}>
                {season.seasonName} - {season.seasonYear}
              </option>
            ))}
          </Select>

          <Button
            type="submit"
            text="تسجيل"
            isDisabled={
              !(
                (formData.fabricTransactionVariantId ||
                  formData.productionAssetId) &&
                formData.processingDate
              )
            }
          />
        </div>
      </div>
    </form>
  );
};

export default FabricVariantTransactionForm;
